import { ReduxState } from '../store';
import { useSelector } from 'react-redux';

export function useSelectedProjectShortName(): string | undefined {
  return useSelector((state: ReduxState) => state.userReducer.selectedProjectShortName);
}
